<template>
  <div>
    <h3 class="my-4">Thông tin tác vụ</h3>
    <div class="card p-3">
      <div class="row">
        <div class="col-6 mb-3">
          <label>Mã tác vụ</label>
          <input class="bg-white d-block w-100 rounded-sm px-3 py-1 form-control " :value="informationTask.taskCode"
            disabled>
        </div>
        <div class="col-6 mb-3">
          <label>Tên tác vụ</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask.taskName">
        </div>
        <div class="col-6 mb-3">
          <label>Loại tác vụ</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask.taskType">
        </div>
        <div class="col-6 mb-3">
          <label>Hình thức test</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask.testForm">
        </div>
        <!--        <div class="col-6 mb-3">-->
        <!--          <label>Loại đề test</label>-->
        <!--          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled :value="informationTask?.typeOfTestQuestion">-->
        <!--        </div>-->
        <div class="col-6 mb-3">
          <label>Ngày làm</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.workday">
        </div>
        <div class="col-6 mb-3">
          <label>Thời gian bắt đầu</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.startTime">
        </div>
        <div class="col-6 mb-3">
          <label>Thời gian kết thúc</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.endTime">
        </div>
        <div class="col-6 mb-3">
          <label>Trung tâm</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.center">
        </div>
        <div class="col-6 mb-3">
          <label>Cơ sở</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.branch">
        </div>
        <div class="col-6 mb-3">
          <label>Họ và tên khách hàng</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.customerName">
        </div>
        <div class="col-6 mb-3">
          <label>Số điện thoại khách hàng</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.customerPhone">
        </div>
        <div class="col-6 mb-3">
          <label>Người đặt lịch</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled
            :value="informationTask?.informationCounselors">
        </div>
        <div class="col-6 mb-3" v-if="informationTask?.bandType && !informationTask?.isC2">
          <label>Loại đề test</label>
          <el-tooltip effect="dark" :content="informationTask?.bandType" placement="top">
            <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled :value="informationTask?.bandType">
          </el-tooltip>
        </div>
        <div class="col-6 mb-3" v-if="informationTask?.gradeLevel">
          <label>Giai đoạn học</label>
          <el-tooltip effect="dark" :content="informationTask?.gradeLevel" placement="top">
            <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control " disabled :value="informationTask?.gradeLevel">
          </el-tooltip>
        </div>
        <div v-if="informationTask.testForm !== 'Online'" class="col-6 mb-3">
          <label>Thời gian bắt đầu vào test</label>
          <input class="bg-white  d-block w-100  rounded-sm px-3 py-1 form-control" disabled
            :value="informationTask?.come_check_date | formatDateTimeAsia">
        </div>
        <div class="col-12 mb-3" v-if="isCoordinator">
          <button type="button" class="btn btn-primary" @click="showModal">Sửa thông tin</button>
        </div>
      </div>
    </div>

    <UpdateStudentInfoModal :visible.sync="dialogVisible" :default-phone="informationTask?.customerPhone"
      :default-name="informationTask?.customerName" :uuid="informationTask?.token" @success="handleUpdateSuccess" />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import UpdateStudentInfoModal from "@/components/UpdateStudentInfoModal.vue";

export default {
  name: "TaskInformation",
  components: {
    ValidationObserver,
    ValidationProvider,
    UpdateStudentInfoModal
  },
  props: {
    informationTask: {
      type: Object,
      default: () => ({})
    },
    isCoordinator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showModal() {
      this.dialogVisible = true;
    },
    handleUpdateSuccess() {
      this.$emit('reload-data');
    }
  }
}
</script>

<style scoped>
input:focus {
  outline: none;
}
</style>